import dayjs from "dayjs";
import { useMutation, useRequest } from "../../utils/api";
import { GeneralProps, ShortMutationConfigType } from "../../utils/api.type";
import {
  CreateCleanJobProps,
  CreateCleanTaskProps,
  DetailCleaningJobsResponse,
  ListAvailableZoneResponse,
  ListCleaningJobsResponse,
} from "./index.type";
import { cleaningOptions } from "../../routes/dashboard/components/CleaningDialog";

export const CLEANING_JOB_STATUS = {
  CANCELLED: "cancelled",
  IN_PROGRESS: "in_progress",
  SCHEDULED: "scheduled",
  COMPLETED: "completed",
  FAILED: "failed",
};

const ENDPOINT_START_CLEANING = "/v1/organisations/:organisationId/task/";
export const useCreateCleaningTaskMutation = (
  options: ShortMutationConfigType & { organisation_id: string }
) => {
  return useMutation<any, CreateCleanTaskProps>(
    ENDPOINT_START_CLEANING.replace(":organisationId", options.organisation_id),
    options
  );
};

const ENDPOINT_START_CLEANING_JOB =
  "/v1/organisations/:organisationId/robot_cleaning_job/create_robot_job/";
export const useCreateCleaningJobMutation = (
  options: ShortMutationConfigType & { organisation_id: string }
) => {
  return useMutation<any, CreateCleanJobProps>(
    ENDPOINT_START_CLEANING_JOB.replace(
      ":organisationId",
      options.organisation_id
    ),
    options
  );
};

const ENDPOINT_LIST_ZONE =
  "/v1/organisations/:organisation_id/cleaning_area/?page_size=100";
export const useListAvailableZones = (
  obj = { enabled: true } as GeneralProps & {
    organisation_id: string;
  }
) => {
  return useRequest<ListAvailableZoneResponse>(
    ENDPOINT_LIST_ZONE.replace(":organisation_id", obj.organisation_id),
    {},
    {
      enabled: obj.enabled,
      cacheKey: JSON.stringify(obj),
    }
  );
};

const ENDPOINT_LIST_JOB = "/v1/organisations/:organisation_id/task/";
export const useListCleaningJobs = (
  obj = { enabled: true } as GeneralProps & {
    organisation_id: string;
    page?: number;
    status?: string;
    robot_id?: string;
    no_end_time?: boolean;
  }
) => {
  return useRequest<ListCleaningJobsResponse>(
    ENDPOINT_LIST_JOB.replace(":organisation_id", obj.organisation_id),
    {
      page_size: 50,
      page: obj.page || 1,
      status: obj.status || "",
      start_time: dayjs(new Date()).startOf("day").unix(),
      end_time: obj.no_end_time ? undefined : dayjs(new Date()).endOf("day").unix(),
      robot_id: obj.robot_id || undefined
    },
    {
      enabled: obj.enabled,
      cacheKey: JSON.stringify(obj),
    }
  );
};

const ENDPOINT_DETAIL_JOB = "/v1/organisations/:organisation_id/task/:task_id";
export const useDetailCleaningJob = (
  obj = { enabled: true } as GeneralProps & {
    organisation_id?: string;
    task_id?: string;
  }
) => {
  return useRequest<DetailCleaningJobsResponse>(
    ENDPOINT_DETAIL_JOB.replace(
      ":organisation_id",
      obj.organisation_id || ""
    ).replace(":task_id", obj.task_id || ""),
    {},
    {
      enabled: obj.enabled,
      cacheKey: JSON.stringify(obj),
    }
  );
};

const ENDPOINT_UPDATE_CLEANING_JOB =
  "/v1/organisations/:organisationId/task/:taskId/";
export const useUpdateCleaningJobMutation = (
  options: ShortMutationConfigType & {
    organisation_id: string;
    task_id: string;
  }
) => {
  return useMutation<any, { status: "cancelled" | string }>(
    ENDPOINT_UPDATE_CLEANING_JOB.replace(
      ":organisationId",
      options.organisation_id
    ).replace(":taskId", options.task_id),
    {
      ...options,
      method: "PUT",
    }
  );
};

export const getCleaningTypeLabel = (type: string) => {
  const find = cleaningOptions.find((item) => item.value.toLowerCase() === type.toLowerCase())
  if (!find) {
    return type.split("_").join(" ");
  }

  return find.label
};
